import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Reviews from './Reviews';
import Footer from './Footer';

const ReviewsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Client Reviews | Notary Public Express Service</title>
        <meta name="description" content="Read what our satisfied clients have to say about our professional notary services in Toronto." />
        <meta property="og:title" content="Client Reviews | Notary Public Express Service" />
        <meta property="og:description" content="Read what our satisfied clients have to say about our professional notary services in Toronto." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://notarypublicexpress.ca/reviews" />
      </Helmet>
      <Header />
      <main>
        <div className="page-header">
          <div className="container">
            <h1>Client Reviews</h1>
            <p>Read what our satisfied clients have to say about our notary services</p>
          </div>
        </div>
        <Reviews />
      </main>
      <Footer />
    </>
  );
};

export default ReviewsPage;